import { useContext } from 'react'

import { useHandlers } from '@pages/DiagramsCreateOrEdit/components/AddBarChartColumnDialog/hooks/useHandlers'
import { PageContext } from '@pages/DiagramsCreateOrEdit/DiagramsCreateOrEdit'

import { useInputs } from './useInputs'

export const useAddBarChartColumnDialog = () => {
  const { objects, series } = useContext(PageContext)

  const { state, handlers, data, methods } = useHandlers()

  const { watch, setValue } = methods

  const watchOperation = watch('operation')
  const watchFields = watch('fields')
  const watchJSForAll = watch('jsForAllFields')
  const watchIsCommandForEverySeries = watch('commandForEverySeries')
  // const watchObject = watch('object')

  const inputs = useInputs({
    watchIsCommandForEverySeries,
    watchOperation,
    watchJSForAll,
    commandOptions: data.commandOptions,
    toggleOpenScriptValueDialog: handlers.toggleOpenScriptValueDialog,
    setCurrentNameScriptDialog: handlers.setCurrentNameScriptDialog,
    handleChangeObject: handlers.handleChangeObject,
    objects,
    watchFields,
    objectFields: data.objectFields,
    setValue,
    series,
  })

  return {
    handlers,
    inputs,
    state,
    methods,
  }
}
